import BliBadge from '@blibli/blue.badge/dist/badge/blue/Badge'
import BliList from '@blibli/blue.lists/dist/lists/blue/List'
import BliLists from '@blibli/blue.lists/dist/lists/blue/Lists'
import BliIconSiAnalytics from '@blibli/blue-dls-library-icon/dist/Analytics'
import BliIconSiCode from '@blibli/blue-dls-library-icon/dist/Code'
import BliIconSiDocument from '@blibli/blue-dls-library-icon/dist/Document'
import BliIconSiLink from '@blibli/blue-dls-library-icon/dist/Link'
import BliIconSiMoney from '@blibli/blue-dls-library-icon/dist/Money'
import BliIconSiPeopleProfile from '@blibli/blue-dls-library-icon/dist/PeopleProfile'
import BliIconSiStoreFavorite from '@blibli/blue-dls-library-icon/dist/StoreFavorite'

import { mapState } from 'pinia'

import { pages } from '@/config'
import { useConfigStore } from '@/stores/config.js'

export default {
  data () {
    return {
      activeTab: []
    }
  },
  components: {
    BliBadge,
    BliList,
    BliLists,
    BliIconSiAnalytics,
    BliIconSiCode,
    BliIconSiDocument,
    BliIconSiLink,
    BliIconSiMoney,
    BliIconSiPeopleProfile,
    BliIconSiStoreFavorite
  },
  computed: {
    ...mapState(useConfigStore, ['generateIframeFeatureFlag']),
    menuGroups () {
      return [
        {
          title: this.$t('sidebar.dashboard'),
          items: [
            {
              label: this.$t('tab.performance'),
              name: pages.performance.name,
              testId: 'performance-sidebar',
              icon: 'BliIconSiAnalytics'
            },
            {
              label: this.$t('tab.commission'),
              name: pages.commission.name,
              testId: 'commission-sidebar',
              icon: 'BliIconSiMoney'
            },
            {
              label: this.$t('sidebar.account'),
              name: pages.profile.name,
              testId: 'account-sidebar',
              icon: 'BliIconSiPeopleProfile'
            }
          ]
        },
        {
          title: this.$t('sidebar.affiliateTools'),
          items: [
            {
              label: this.$t('tab.generateLink'),
              name: pages.generateLink.name,
              testId: 'generate-link-sidebar',
              icon: 'BliIconSiLink'
            },
            {
              label: this.$t('tab.banner'),
              name: pages.banner.name,
              testId: 'banner-sidebar',
              icon: 'BliIconSiCode',
              badge: 'New',
              hidden: !this.generateIframeFeatureFlag
            },
            {
              label: this.$t('tab.bonusCommission'),
              name: pages.bonusCommission.name,
              testId: 'featured-sellers-sidebar',
              icon: 'BliIconSiStoreFavorite'
            },
            {
              label: this.$t('tab.contract'),
              name: pages.contract.name,
              testId: 'contract-sidebar',
              icon: 'BliIconSiDocument'
            }
          ].filter(item => !item.hidden)
        }
      ]
    }
  },
  methods: {
    navigate (item) {
      this.$router.push({ name: item.name })
    },
    setActiveTab () {
      let name = this.$route.name
      if (this.$route.name === pages.changePassword.name ||
          this.$route.name === pages.bankInformation.name) {
        name = pages.profile.name
      }
      this.activeTab.push(name)
    }
  },
  mounted () {
    this.setActiveTab()
  }
}
